import React, { useEffect, useRef, useState } from 'react';
import MutiSelectDropDown from "../../Components/ModalPopup/FormModules/MutiSelectDropDown";
import { Helpers } from '../../Helpers';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import intlTelInput from "intl-tel-input";
import "intl-tel-input/build/css/intlTelInput.css";
import { Utils } from '../../Utils';
import { useDispatch, useSelector } from 'react-redux';
import { addDays, formatLabel, getDisplayYear, getLastDayOfMonth, getToday, getYearFormat } from '../DateFn';
import { ConfigAutoGenNoModal } from '../ModalPopup/ConfigAutoGenNoModal';
import settingIcon from '../../Assets/images/header-icons/setting-icon.svg';
import { getIndustrySuggestionStart } from '../../Store/Slices/scrapperSlice';
import Select from 'react-select';
import axios from 'axios';
import { getItem } from '../../Services/localService';

const CustomInput = ({ DealName, items, sectionIndex, storeData, setStoreData, error, setErrors, preview, listItems,
  handleBlurMaterialNumber, handleBlurReferenceMaterial, users, lookupData = null, variants = null,
  modules = null, setMainModuleSubFormChangeModal, customInputs = [], openCheckBoxFieldModal, openParticipantModal,
  configData = [], id, configType, setConfigType, prefix, setPrefix, nextNumber, setNextNumber, transactionYear,
  currentCurrencyData, fromAddNewModal, industrySuggestionData, setLookType, stagePercentage, setStagePercentage,
  stageValue, setStageValue, isPreview = null
}) => {
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  // let scrapperData = useSelector((state) => state.scrapper);
  // let industrySuggestionData = scrapperData?.industrySuggestionData;
  let formList = useSelector((state) => state?.forms);
  let currentOrg = useSelector((state) => state?.org);

  let [input_id] = useState(items?.id || {});
  let [input_type] = useState(items?.input_type || {});

  let [extra_fields] = useState(items?.extra_fields || {});
  let [fieldLabel] = useState(extra_fields?.field_label || '');
  let [lookupDatas, setLookupDatas] = useState([]);
  let [key] = useState(Helpers.replaceData(fieldLabel));
  let [maxLength] = useState(extra_fields?.number_of_characters_allowed || undefined);
  let [charLimit] = useState(extra_fields?.character_limit || undefined);
  let [showTooltip] = useState(extra_fields?.show_tooltip || null);
  let [isShowIconHoverTooltip] = useState(showTooltip?.checked && showTooltip?.type === 'info' && showTooltip?.message?.length > 0);
  let [isShowInputHoverTooltip] = useState(showTooltip?.checked && showTooltip?.type === 'static' && showTooltip?.message?.length > 0);
  let utilsScriptUrl = "https://cdn.jsdelivr.net/npm/intl-tel-input@19.1.0/build/js/utils.js";
  let inputRef = useRef(null);
  let iti = null;
  // auto gen num works
  let [showAutoGenModal, setShowAutoGenModal] = useState(false)
  let [configModuleType, setConfigModuleType] = useState('')
  // transaction year
  const { previousAndCurrentYear, currentAndNextYear } = getYearFormat()

  let [industryData, setIndustryData] = useState([])
  let [fileData, setFileData] = useState([]);

  // useEffect(() => {
  //   dispatch(getIndustrySuggestionStart({ search: "", count: 10 }))
  // }, []);

  useEffect(() => {
    if (industrySuggestionData?.length) {
      setIndustryData(industrySuggestionData?.map((data) =>
        ({ value: data?.department, label: formatLabel(data?.department) })
      ))
    }
  }, [industrySuggestionData])

  const handleIndustryInput = (e) => {
    if (e.trim().length === 0) return;
    dispatch(getIndustrySuggestionStart({ search: e, count: 10 }))
  }

  useEffect(() => {
    if (lookupData?.hasOwnProperty(fieldLabel) && !preview) {
      let list = lookupData[fieldLabel];
      let data = [];
      if (list?.length > 0) {
        for (let x of list) {
          if (x?.data?.length > 0) {
            for (let y of x?.data) {
              let title = extra_fields?.related_list_title?.trim();
              let possibleKeys = [Helpers.replaceData(title), Helpers.replaceData(title + "_")];
              for (let key of possibleKeys) {
                let val = y?.section_data?.[key] || null;
                if (y?.section_data?.hasOwnProperty(key) && !Array.isArray(val) && val) {
                  data.push({ _id: x?._id, name: (typeof val === "string" ? val : (val?.name || "")) });
                  break;
                }
              }
            }
          }
        }
      }
      setLookupDatas(data);
    } else if (items?.input_type === "lookup" && extra_fields?.is_module_lookup) {
      setLookupDatas(formList?.navbarList);
    } else {
      setLookupDatas([]);
    }
  }, [lookupData]);

  let setValue = (key, value) => {
    setStoreData((prevStoreData) => {
      return {
        ...prevStoreData,
        data: prevStoreData?.data?.map((item) => {
          if (item?.section_data?.hasOwnProperty(key)) {
            return {
              ...item,
              section_data: {
                ...item.section_data,
                [key]: value,
              },
            };
          }
          return item;
        }),
      };
    });
  }

  let checkFunction = () => {
    let data = [];
    variants?.forEach(x => {
      let parentLabel = Helpers.replaceData(x?.parent_field);
      let childLabel = Helpers.replaceData(x?.child_field);
      storeData?.data?.forEach(y => {
        let parentData = y?.section_data?.[parentLabel];
        if ((parentData === x?.[parentLabel]) && (childLabel === key)) {
          data = x?.[childLabel];
          // if ((y?.section_data?.[Helpers.replaceData(x?.parent_field)] === x?.[Helpers.replaceData(x?.parent_field)]) && (Helpers.replaceData(x?.child_field) === key)) {
          //   data = x?.[Helpers.replaceData(x?.child_field)];
        }
      });
    });
    return data;
  }
  let pickListOptions = checkFunction();
  let getValues = () => {

    let val = extra_fields?.default_value || '';
    let possibleKeys = [Helpers.replaceData(key), Helpers.replaceData(key + "_")];
    for (let key2 of possibleKeys) {
      let section_data = storeData?.data?.[sectionIndex]?.section_data;
      if (section_data?.hasOwnProperty(key2) && section_data?.[key2] !== undefined && section_data?.[key2]) {
        val = section_data[key2];
        break
      }
    }
    // debugger
    // if (input_type === 'file') {
    //   setFileData(prev => {
    //     if (prev.some(item => item.id === input_id)) {
    //       return prev; // no re-render
    //     }
    //     return [...prev, { id: input_id, value: val }];
    //   });
    // }

    return val;
  }
  let labelValue = getValues();

  useEffect(() => {
    if (input_type !== "file") return;

    const val = getValues();
    if (!val) return;

    setFileData(prev => {
      if (prev.some(item => item.id === input_id)) {
        return prev;
      }
      return [...prev, { id: input_id, value: val }];
    });
  }, [
    input_type,
    input_id,
    storeData,
    sectionIndex
  ]);

  // console.log('labelValue', labelValue)
  let [checkModuleNames] = useState(["Article Master", "Article Master Generic"]);


  let termsChange = (value) => {
    let today = new Date();
    if (value === 'Net 15') {
      return addDays(15)
    }
    if (value === 'Net 30') {
      return addDays(30)
    }
    if (value === 'Net 45') {
      return addDays(45)
    }
    if (value === 'Net 60') {
      return addDays(60)
    }
    if (value === 'Due On Receipt' || value === 'Custom') {
      return getToday()
    }
    if (value === 'Due end of the month') {
      return getLastDayOfMonth(today.getFullYear(), today.getMonth())
    }
    if (value === 'Due end of the next month') {
      return getLastDayOfMonth(today.getFullYear(), today.getMonth() + 1)
    }
  }

  let handleAutoNumber = (data) => {
    let value = data.config_type === "autogen" ? data.prefix + data.next_number : ''
    setStoreData((prevStoreData) => {
      let updatedData = JSON.parse(JSON.stringify(prevStoreData));
      for (let i = 0; i <= sectionIndex; i++) {
        if (!updatedData?.data?.[i]?.hasOwnProperty("section_name") || !updatedData?.data?.[i]?.hasOwnProperty("section_data")) {
          updatedData.data[i] = {
            section_name: listItems?.sections?.[i]?.section_name,
            section_data: {}
          };
        }
      }
      updatedData.data[sectionIndex]["section_data"][key] = value;
      try {
        if (variants?.length > 0) {
          let addData = [];
          variants?.forEach(x => {
            let parentLabel = Helpers.replaceData(x?.parent_field);
            let childLabel = Helpers.replaceData(x?.child_field);
            updatedData?.data?.forEach((y, i) => {
              let parentData = y?.section_data?.[parentLabel] || null;
              let childData = y?.section_data?.[childLabel] || null;
              if (childData && !parentData && x?.[childLabel]?.includes(childData) && (key !== parentLabel)) {
                addData.push({
                  sectionIndex: updatedData.data?.findIndex(findData => findData?.section_data?.hasOwnProperty(parentLabel)),
                  key: parentLabel,
                  value: x?.[parentLabel]
                })
              }
            })
          });
          addData.forEach(x => {
            if (updatedData?.data?.[x.sectionIndex]) {
              updatedData.data[x.sectionIndex]["section_data"][x.key] = x.value;
            }
          });
        }
      } catch (e) { }
      return updatedData;
    });
    setShowAutoGenModal(false)
  }

  let [init, setInit] = useState(true)
  useEffect(() => {
    if (!DealName || !modules?.stageProbability?.length) return;

    const dealInfo =
      storeData.data.find((s) => s.section_name === "Deal Information")?.section_data ?? {};

    if (!dealInfo.Stage) {
      const selectedStage = modules.stageProbability.find(
        (s) => s.stageName === DealName
      );
      if (init)
        if (selectedStage) {
          setStageValue(DealName);
          setStagePercentage(selectedStage.probability);

          setStoreData((prev) => {
            const updatedData = prev.data.map((section) => {
              if (section.section_name === "Deal Information") {
                return {
                  ...section,
                  section_data: {
                    ...section.section_data,
                    Stage: String(selectedStage.id),
                    Probability_: selectedStage.probability
                  },
                };
              }
              return section;
            });
            return { ...prev, data: updatedData };
          });
          setInit(true)
        }
    }
  }, [DealName, modules, storeData]);

  // const getCurrency = (amt) => {
  //   return parseFloat(amt.replace(/,/g, '')).toFixed(2)
  // }

  const headers = (isMultipart = false) => {
    const header = {
      Authorization: `Bearer ${getItem("token")}`,
      "Content-Type": "application/json",
    }

    if (isMultipart) {
      header['Content-Type'] = 'multipart/form-data'
    }
    return header

  };


  let handleInputChange = async (e, type) => {
    let isUrl = false; let url = '';
    const file = e.target.files?.[0];
    // if (!file) return;
    if (file)
      try {
        // Create form data
        const formData = new FormData();
        formData.append("file", file);
        const res = await axios.post(`${BACKEND_URL}/form-sub-module/upload-form-img-file`, formData, { headers: headers(true) });
        if (res?.data?.success && res?.data?.s3Url) {
          isUrl = true; url = res?.data?.s3Url
          // let obj = {
          //   id: e?.target?.id,
          //   value: res?.data?.s3Url
          // }
          // debugger
          // setFileData(prev => [...prev, obj]);

          setFileData(prev =>
            prev.some(item => item.id === e?.target?.id)
              ? prev.map(item =>
                item.id === e?.target?.id
                  ? { ...item, value: res?.data?.s3Url }
                  : item
              )
              : [...prev, { id: e?.target?.id, value: res?.data?.s3Url }]
          );

        }
      } catch (err) {
        console.error("File upload error:", err);
      }

    if (!preview) {
      if (modules.name.toLowerCase().trim() === "deals" && extra_fields?.field_label.toLowerCase().trim() === "stage") {
        setStageValue(null)
        const selectedStageId = e.target.value;
        const selectedStage = modules?.stageProbability?.find(s => String(s.id) === selectedStageId);
        if (selectedStage) {
          setStagePercentage(selectedStage.probability); // save percentage
          setStoreData((prev) => {
            const updatedData = prev.data.map((section) => {
              if (section.section_name === "Deal Information") {
                const hasAmount =
                  section.section_data?.Amount &&
                  Number(section.section_data.Amount) > 0;
                const expRevenue = Number(section.section_data.Amount) *
                  (Number(selectedStage.probability) / 100);

                return {
                  ...section,
                  section_data: {
                    ...section.section_data,
                    Probability_: selectedStage.probability,
                    ...(hasAmount && {
                      Expected_Revenue: Math.round(expRevenue)
                    }),
                  },
                };
              }
              return section;
            });
            return { ...prev, data: updatedData };
          });
        } else {
          setStagePercentage(null); // reset if nothing selected
        }

        // let value = modules?.stageProbability?.find(item => item?.id === Number(e?.target?.value))?.probability;
        // labelValue = value;
      }

      if (modules.name.toLowerCase().trim() === "deals" && extra_fields?.field_label.toLowerCase().trim() === "amount") {
        setStoreData((prev) => {
          const updatedData = prev.data.map((section) => {
            if (section.section_name === "Deal Information") {
              if (section?.section_data?.Stage) {
                const hasAmount =
                  e?.target?.value &&
                  Number(e?.target?.value) > 0;
                const expRevenue = Number(e?.target?.value) *
                  (Number(section?.section_data?.Probability_) / 100);

                return {
                  ...section,
                  section_data: {
                    ...section.section_data,
                    ...(hasAmount && {
                      Expected_Revenue: Math.round(expRevenue)
                    }),
                  },
                };
              }
            }
            return section;
          });
          return { ...prev, data: updatedData };
        });
      }

      if (modules.name.toLowerCase().trim() === "deals" && extra_fields?.field_label.toLowerCase().trim() === "probability") {
        setStoreData((prev) => {
          const updatedData = prev.data.map((section) => {
            if (section.section_name === "Deal Information") {
              if (section?.section_data?.Stage && section.section_data.Amount) {
                const hasAmount =
                  section.section_data?.Amount &&
                  Number(section.section_data.Amount) > 0;
                const expRevenue = Number(section.section_data.Amount) *
                  (Number(e?.target?.value) / 100);

                return {
                  ...section,
                  section_data: {
                    ...section.section_data,
                    ...(hasAmount && {
                      Expected_Revenue: Math.round(expRevenue)
                    }),
                  },
                };
              }
            }
            return section;
          });
          return { ...prev, data: updatedData };
        });
      }

      if (modules?.name?.toLowerCase().trim() === "deals" &&
        extra_fields?.field_label?.toLowerCase().trim() === "probability") {
        setStagePercentage(null);
      }
    }
    let target = type !== 'label' && e?.target;
    let value = isUrl ? url : type !== 'label' ? target?.type === "checkbox" ? (target.checked ? "X" : "") : target.value : e?.label;
    if (preview || !storeData) return value;
    if (charLimit && value.length > charLimit) {
      value = value.substring(0, charLimit);
    }

    setStoreData((prevStoreData) => {
      let updatedData = JSON.parse(JSON.stringify(prevStoreData));
      for (let i = 0; i <= sectionIndex; i++) {
        if (!updatedData?.data?.[i]?.hasOwnProperty("section_name") || !updatedData?.data?.[i]?.hasOwnProperty("section_data")) {
          updatedData.data[i] = {
            section_name: listItems?.sections?.[i]?.section_name,
            section_data: {}
          };
        }
      }
      // debugger
      // terms field fn::start-dp
      if (modules?.name === 'Invoices' && key === 'Terms') {
        updatedData.data[sectionIndex]["section_data"]["Due_Date"] = termsChange(value);
      }
      if (modules?.name === 'Invoices' && key === 'Due_Date') {
        updatedData.data[sectionIndex]["section_data"]["Terms"] = 'Custom';
      }
      // terms field fn::end-dp
      updatedData.data[sectionIndex]["section_data"][key] = value;
      try {
        if (variants?.length > 0) {
          // debugger
          let addData = [];
          variants?.forEach(x => {
            if (x?.parent_field !== "Lead Status" && x?.child_field !== "Lead Source") {
              let parentLabel = Helpers.replaceData(x?.parent_field);
              let childLabel = Helpers.replaceData(x?.child_field);
              updatedData?.data?.forEach((y, i) => {
                let parentData = y?.section_data?.[parentLabel] || null;
                let childData = y?.section_data?.[childLabel] || null;
                if (childData && !parentData && x?.[childLabel]?.includes(childData) && (key !== parentLabel)) {
                  addData.push({
                    sectionIndex: updatedData.data?.findIndex(findData => findData?.section_data?.hasOwnProperty(parentLabel)),
                    key: parentLabel,
                    value: x?.[parentLabel]
                  })
                }
              })
            }
          });
          addData.forEach(x => {
            if (updatedData?.data?.[x.sectionIndex]) {
              updatedData.data[x.sectionIndex]["section_data"][x.key] = x.value;
            }
          });
        }
      } catch (e) { }
      return updatedData;
    });
    setErrors((error) => ({ Material_Number: error?.["Material_Number"] || "" }));
  };

  const removeById = (id) => {
    setFileData((prevItems) =>
      prevItems.filter(item => item.id !== id)
    );
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    handleInputChange({ target: { value: "" } });
  };

  useEffect(() => {
    let handleChange = () => {
      let fullNumber = iti?.getNumber();
      handleInputChange({
        target: {
          value: fullNumber
        }
      })
    };
    if (inputRef?.current && items?.input_type === "tel") {
      iti = intlTelInput(inputRef.current, {
        initialCountry: "in",
        utilsScript: utilsScriptUrl,
      });
      inputRef.current.addEventListener("input", handleChange);
    }
    return () => {
      if (iti) {
        iti = null;
      }
      if (inputRef?.current) {
        inputRef.current.removeEventListener("input", handleChange);
      }
    };
  }, [items?.input_type]);

  let getFormFloatClass = () => {
    return ["multi-select", "multi-lookup", "user", "lookup"]?.includes(items?.input_type);
  }


  const formatNumber = (amount) => {
    return new Intl.NumberFormat(currentCurrencyData?.digit_format, {
      style: "decimal",
      minimumFractionDigits: currentCurrencyData?.decimal_place,
      maximumFractionDigits: currentCurrencyData?.decimal_place,
    }).format(amount);
  };

  const formatCurrNumInput = (value) => {
    if (typeof value === 'number') return value;
    if (typeof value !== 'string') return 0;
    return value
      .replace(/\s| /g, '')
      .replace(/\.(?=\d{3,}(,|$))/g, '')
      .replace(/,(?=\d{3,}(\.|$))/g, '')
      .replace(',', '.');
  }


  let formulaBlur = (type) => {
    let listOfFormula = Utils.getModuleFields(modules?.fields?.sections, ["formula"])?.moduleFields;
    if (listOfFormula?.length > 0) {
      try {
        let updatedStoreData = { ...storeData };
        let calculateFormula = (formula, objData) => {
          return formula?.replace(/\${(.*?)}/g, (match, variable) => {
            let keys = variable?.split('.');
            return objData?.[Helpers.replaceData(keys?.[1])] || 0;
            // let val = objData?.[Helpers.replaceData(keys?.[1])] || 0;
            // return formatCurrNumInput(val);
          });
        };
        let processedData = storeData?.data?.reduce((acc, curr) => ({
          ...acc,
          ...curr?.section_data
        }), {});
        listOfFormula?.forEach((checkFormula) => {
          let expressionExtraFields = checkFormula?.fields?.extra_fields;
          if (expressionExtraFields?.formula_expression) {
            let result;
            let processedFormula = calculateFormula(expressionExtraFields?.formula_expression, processedData);
            result = eval(processedFormula);
            updatedStoreData.data[checkFormula?.sectionIndex].section_data[Helpers.replaceData(expressionExtraFields?.field_label)] = Math.round(result);
          }
        });
        setStoreData(updatedStoreData);
      } catch (err) { }
    }

    if (type === 'currency') {
      setStoreData((prevStoreData) => {
        let updatedData = JSON.parse(JSON.stringify(prevStoreData));
        let amount = updatedData.data[sectionIndex]["section_data"][key]
        updatedData.data[sectionIndex]["section_data"][key] = amount
        // updatedData.data[sectionIndex]["section_data"][key] = formatNumber(amount)
        return updatedData;
      });
      // let updatedData = JSON.parse(JSON.stringify(prevStoreData));
      // let updatedStoreData = { ...storeData };
      // let amount = updatedStoreData.data[sectionIndex]["section_data"][key]
      // updatedStoreData.data[sectionIndex].section_data[key] = formatNumber(amount)
      // setStoreData(updatedStoreData);
    }
  }

  let getDisplayValue = (key, labelValue, display) => {
    let valueTemplate = display[key] || display?.default;
    return valueTemplate.replace(/\${(.*?)}/g, (_, key) => labelValue[key] || '');
  };

  let selectedOption = industryData.find((opt) => opt.label === labelValue) || null;

  if (!selectedOption && labelValue) {
    const newOption = {
      value: labelValue,
      label: labelValue
    };
    setIndustryData((prev) => [...prev, newOption]);
    selectedOption = newOption;
  }

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Extra safety check (optional)
    if (!file.type.startsWith("image/")) {
      alert("Please select an image file");
      return;
    }
  };
  // console.log("filesData", fileData)
  // console.log('items--->', items)
  return (
    <>
      <div className={`mb-3 form-fields-page ${(isShowIconHoverTooltip || ["tel", "lookup", "multi-lookup"]?.includes(items?.input_type)) ? (getFormFloatClass() ? 'form-normal' : items?.input_type !== 'file' && 'form-floating') : ''}`}>
        <OverlayTrigger
          placement="bottom-start"
          overlay={
            <Tooltip id={`tooltip-${items?.id}`}>
              {showTooltip?.message || ""}
            </Tooltip>
          } {...(isShowInputHoverTooltip ? {} : { show: false })}>
          <div className={`${items?.input_type === "text" && extra_fields?.field_label === "Participants" ? "d-flex justify-content-between align-items-center" : ""} ${(isShowIconHoverTooltip || ["tel", "lookup", "multi-lookup"]?.includes(items?.input_type)) ? 'input-group' : (getFormFloatClass() ? 'form-normal' : items?.input_type !== 'file' && 'form-floating')}`}>
            {/* {(items?.input_type === 'text' && !customInputs?.includes(key)) && ( */}
            {(items?.input_type === 'text') && (
              <>
                {key === "Product_Hierarchy" && checkModuleNames.includes(modules?.name) ? (
                  <>
                    <input
                      type="text"
                      className={`form-control ${error ? 'is-invalid' : ''}`}
                      id={items?.id} placeholder={fieldLabel || ""}
                      onChange={handleInputChange}
                      value={labelValue || ''}
                      maxLength={maxLength}
                      required={extra_fields?.required}
                      readOnly
                    />
                    <span className="badge bg-primary mt-1">Read Only</span>
                  </>
                ) : (key === "Material_Number" && checkModuleNames.includes(modules?.name) ?
                  <>
                    <input
                      type="text"
                      className={`form-control ${error ? 'is-invalid' : (labelValue ? 'is-valid' : '')}`}
                      id={items?.id} placeholder={fieldLabel || ""}
                      onChange={handleInputChange}
                      onBlur={handleBlurMaterialNumber}
                      value={labelValue || ''}
                      maxLength={maxLength}
                      required={extra_fields?.required}
                    />

                  </> : <>
                    {extra_fields?.field_label === "Participants" ?
                      (<>
                        <div className="d-flex">
                          <span>Participants : <span className='cursor-pointer' onClick={() => preview ? {} : openParticipantModal(key)}>Selected({
                            ((labelValue?.selectedData || [])
                              ?.reduce((acc, item) => acc + (item?.data?.length || 0), 0) || 0)
                            + (labelValue?.inviteEmails?.length || 0)
                          })</span>
                          </span>
                          <a className='cursor-pointer ms-2 text-link' onClick={() => preview ? {} : openParticipantModal(key)}>+ Add</a>
                        </div>
                      </>) :
                      (<>
                        <input
                          type="text"
                          className={`form-control ${error ? 'is-invalid' : ''}`}
                          id={items?.id}
                          placeholder={fieldLabel || ""}
                          onChange={handleInputChange}
                          onBlur={handleBlurReferenceMaterial}
                          value={labelValue || ''}
                          maxLength={maxLength}
                          required={extra_fields?.required}
                        />
                        {(fieldLabel === 'Quote Number' || fieldLabel === 'SO Number' || fieldLabel === 'Invoice Number') &&
                          <button type="button" style={{ position: 'absolute', top: '22%', right: '2%' }} className="nav-link p-0"
                            onClick={() => { setShowAutoGenModal(true); setConfigModuleType(modules?.name) }}>
                            <img src={settingIcon} alt="setting-icon" width="20" height="20" />
                          </button>
                        }
                      </>)
                    }
                  </>
                )}
              </>
            )}
            {items?.input_type === 'formula' && (
              <input
                type="text"
                className={`form-control ${error ? 'is-invalid' : ''}`}
                id={items?.id}
                placeholder={fieldLabel || ""}
                value={labelValue || ''}
                maxLength={maxLength}
                required={extra_fields?.required}
                disabled
              />
            )}
            {items?.input_type === 'email' && (
              <input
                type="email"
                className={`form-control ${error ? 'is-invalid' : ''}`}
                id={items?.id}
                placeholder={fieldLabel || ""}
                onChange={handleInputChange}
                value={labelValue || ''}
                maxLength={maxLength}
                required={extra_fields?.required}
              />
            )}
            {items?.input_type === 'number' && (
              <>
                {modules?.name?.toLowerCase().trim() === "deals" &&
                  extra_fields?.field_label?.toLowerCase().trim() === "probability" ?
                  <input
                    type="number"
                    className={`form-control ${error ? 'is-invalid' : ''}`}
                    id={items?.id}
                    placeholder={fieldLabel || ""}
                    onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
                    onChange={handleInputChange}
                    onBlur={formulaBlur}
                    value={stagePercentage !== null ? stagePercentage : labelValue || ''}
                    maxLength={maxLength}
                    required={extra_fields?.required}
                  />
                  :
                  <input
                    type="number"
                    className={`form-control ${error ? 'is-invalid' : ''}`}
                    id={items?.id}
                    placeholder={fieldLabel || ""}
                    onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
                    onChange={handleInputChange}
                    onBlur={formulaBlur}
                    value={labelValue || ''}
                    maxLength={maxLength}
                    required={extra_fields?.required}
                  />
                }
              </>
            )}
            {items?.input_type === 'percent' && (
              <input
                type="number"
                className={`form-control ${error ? 'is-invalid' : ''}`}
                id={items?.id}
                placeholder={fieldLabel || ""}
                onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
                onChange={handleInputChange}
                value={labelValue || ''}
                maxLength={maxLength}
                required={extra_fields?.required}
                onBlur={formulaBlur}
              />
            )}
            {items?.input_type === 'auto_number' && (
              <input
                type="text"
                className={`form-control ${error ? 'is-invalid' : ''}`}
                id={items?.id}
                placeholder={fieldLabel || ""}
                value={`${extra_fields?.prefix}${extra_fields?.startingNumber}${extra_fields?.suffix}`}
                onChange={handleInputChange}
                maxLength={maxLength}
                required={extra_fields?.required}
              />
            )}
            {items?.input_type === 'decimal' && (
              <input
                type="number"
                className={`form-control ${error ? 'is-invalid' : ''}`}
                id={items?.id}
                placeholder={fieldLabel || ""}
                onChange={handleInputChange}
                value={labelValue || ''}
                maxLength={maxLength}
                required={extra_fields?.required}
                onBlur={formulaBlur}
                step="any"
              />
            )}
            {items?.input_type === 'longinteger' && (
              <input
                type="text"
                className={`form-control ${error ? 'is-invalid' : ''}`}
                id={items?.id}
                placeholder={fieldLabel || ""}
                onChange={handleInputChange}
                value={labelValue || ''}
                maxLength={maxLength}
                required={extra_fields?.required}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                }}
              />
            )}
            {items?.input_type === 'password' && (
              <input type="password" className={`form-control ${error ? 'is-invalid' : ''}`} id={items?.id} placeholder={fieldLabel || ""} onChange={handleInputChange} value={labelValue || ''} maxLength={maxLength} required={extra_fields?.required} />
            )}
            {(items?.input_type === 'checkbox' && !extra_fields?.check_box_modal_name) && (
              <div className={`form-check pt-1 ${error ? 'is-invalid' : ''}`}>
                <input
                  className="form-check-input mt-2 border-dark-subtle"
                  type="checkbox"
                  id={items?.id}
                  placeholder={fieldLabel || ""}
                  onChange={handleInputChange}
                  checked={extra_fields?.checked || labelValue === 'X'}
                  required={extra_fields?.required}
                />
              </div>
            )}
            {(items?.input_type === 'checkbox' && extra_fields?.check_box_modal_name) && (
              <>
                <div className={`form-check pt-1 ${error ? 'is-invalid' : ''}`}>
                  <input
                    className="form-check-input mt-2 border-dark-subtle"
                    type="checkbox"
                    id={items?.id}
                    placeholder={fieldLabel || ""}
                    onChange={(e) => {
                      if (!preview) {
                        let checked = e?.target?.checked;
                        if (checked) {
                          openCheckBoxFieldModal({
                            label: fieldLabel || "",
                            modalName: extra_fields?.check_box_modal_name
                          });
                        } else {
                          handleInputChange(e);
                        }
                      }
                    }}
                    checked={Object.keys(labelValue || {})?.length > 0}
                    required={extra_fields?.required}
                    disabled={extra_fields?.validation_field ? !Utils.getSubFormFieldToData(Helpers.replaceData(extra_fields?.validation_field), storeData?.data) || null : false}
                  />
                </div>
                {Object?.keys(labelValue || {})?.length > 0 ? <span className="cursor-pointer" onClick={() => {
                  if (!preview) {
                    openCheckBoxFieldModal({
                      label: fieldLabel || "",
                      modalName: extra_fields?.check_box_modal_name
                    });
                  }
                }}>( {Object.keys(Helpers.getValidObjectOrEmpty(extra_fields?.display)).reduce((acc, key) => {
                  if (labelValue.hasOwnProperty(key)) {
                    acc = getDisplayValue(key, Helpers.getValidObjectOrEmpty(labelValue), Helpers.getValidObjectOrEmpty(extra_fields?.display));
                  }
                  return acc;
                }, getDisplayValue('default', Helpers.getValidObjectOrEmpty(labelValue), Helpers.getValidObjectOrEmpty(extra_fields?.display)))} )</span> : <></>}
              </>
            )}
            {items?.input_type === 'radio' && (
              <div className={`form-check pt-1 ${error ? 'is-invalid' : ''}`}>
                <input type="radio" className="form-check-input mt-2" id={items?.id} placeholder={fieldLabel || ""} name={extra_fields?.name} onChange={handleInputChange} checked={labelValue === 'X'} />
              </div>
            )}
            {items?.input_type === 'textarea' && (
              <textarea rows="4" cols="50" style={{ height: "auto" }} className={`form-control ${error ? 'is-invalid' : ''}`} id={items?.id} placeholder={fieldLabel || ""} onChange={handleInputChange} value={labelValue || ''} maxLength={maxLength} required={extra_fields?.required}></textarea>
            )}
            {items?.input_type === 'select' && (
              <>
                {extra_fields?.field_label === "Transaction Year" ?
                  <select
                    className={`form-select ${error ? 'is-invalid' : ''}`}
                    id={items?.id}
                    placeholder={fieldLabel || ""}
                    // value={labelValue || ''}
                    value={labelValue || getDisplayYear(transactionYear)}
                    onChange={handleInputChange}
                    required={extra_fields?.required}
                  >
                    <option value="">Select</option>
                    {transactionYear === 'january' ?
                      <>
                        {previousAndCurrentYear?.map((data) => (
                          <option key={data} value={data}>{data}</option>
                        ))}
                      </>
                      :
                      <>
                        {currentAndNextYear?.map((data) => (
                          <option key={data} value={data}>{data}</option>
                        ))}
                      </>
                    }
                  </select>
                  : modules?.name === "Prospects" && extra_fields?.field_label === "Industry" ? (
                    <Select
                      options={industryData}
                      onInputChange={handleIndustryInput}
                      placeholder="Industry"
                      value={selectedOption}
                      // value={industryData.find(opt => opt.label === labelValue) || null}
                      onChange={(e) => handleInputChange(e, 'label')}
                      isClearable
                      required={extra_fields?.required}
                    />
                  ) : modules?.name?.toLowerCase().trim() === "deals" &&
                    extra_fields?.field_label?.toLowerCase().trim() === "stage" ?
                    (
                      <select
                        className={`form-select ${error ? 'is-invalid' : ''}`}
                        id={items?.id}
                        placeholder={fieldLabel || ""}
                        value={(DealName && stageValue) ? modules?.stageProbability?.find(s => s.stageName === DealName)?.id || '' : labelValue || ''}
                        onChange={handleInputChange}
                        required={extra_fields?.required}
                      >
                        <option value="">Select</option>
                        {modules?.stageProbability?.map((data, index) => (
                          <option value={data?.id} key={index}>{data?.stageName}</option>
                        ))}
                        {/* {(pickListOptions?.length > 0 ? [...pickListOptions] : [...extra_fields?.options])?.sort((a, b) => extra_fields.order_preference === 'Alphabetical order' ? a.localeCompare(b) : 0).map((option, index) => (
                          <option value={option} key={`${sectionIndex}-${index}`}>
                            {option}
                          </option>
                        ))} */}
                      </select>
                    ) : (<select
                      className={`form-select ${error ? 'is-invalid' : ''}`}
                      id={items?.id}
                      placeholder={fieldLabel || ""}
                      value={labelValue || ''}
                      onChange={handleInputChange}
                      required={extra_fields?.required}
                    >
                      <option value="">Select</option>
                      {(pickListOptions?.length > 0 ? [...pickListOptions] : [...extra_fields?.options])?.sort((a, b) => extra_fields.order_preference === 'Alphabetical order' ? a.localeCompare(b) : 0).map((option, index) => (
                        <option value={option} key={`${sectionIndex}-${index}`}>
                          {option}
                        </option>
                      ))}
                    </select>
                    )
                }
              </>
            )}
            {items?.input_type === 'lookup' && (
              <div className={`form-control multi-select border-0 p-0 ${extra_fields?.required ? "unique" : ""}`}>
                <label htmlFor={items?.id}>
                  {fieldLabel}
                </label>
                <MutiSelectDropDown labelValue={labelValue} preview={preview} options={preview ? (typeof labelValue === "string" ? null : [labelValue]) : lookupDatas} handleInputChange={handleInputChange} default_value={typeof labelValue === "string" ? null : labelValue} singleSelect={true} />
              </div>
            )}
            {items?.input_type === 'multi-select' && (
              <div className={`form-control multi-select border-0 p-0 ${extra_fields?.required ? "unique" : ""}`}>
                <label htmlFor={items?.id}>
                  {fieldLabel}
                </label>
                <MutiSelectDropDown
                  preview={preview}
                  options={extra_fields?.options}
                  handleInputChange={handleInputChange}
                  default_value={labelValue}
                  required={extra_fields?.required}
                />
              </div>
            )}
            {(items?.input_type === 'multi-lookup') && (
              <div className={`form-control multi-select border-0 p-0 ${extra_fields?.required ? "unique" : ""}`}>
                <label htmlFor={items?.id}>
                  {fieldLabel}
                </label>
                {preview ?
                  <MutiSelectDropDown preview={preview} options={labelValue || []} handleInputChange={handleInputChange} default_value={labelValue} /> : <MutiSelectDropDown preview={preview} options={lookupDatas} handleInputChange={handleInputChange} default_value={labelValue} />}
              </div>
            )}
            {items?.input_type === 'currency' && (
              <div className="input-group mt-0">
                {/* <span className={`input-group-text bg-white ${extra_fields?.required ? "unique" : ""}`}>{Utils.currencySymbols(currentOrg?.homeCurrencies?.currency_code || "")}</span> */}
                {currentCurrencyData?.currency_code && (
                  <span className={`input-group-text bg-white ${extra_fields?.required ? "unique" : ""}`}>{currentCurrencyData?.currency_code || ""}</span>
                )}
                <input type="text"
                  className={`form-control ${error ? 'is-invalid' : ''} border-start-0-`}
                  id={items?.id} placeholder={fieldLabel || ""}
                  onChange={handleInputChange}
                  value={labelValue || ""}
                  maxLength={maxLength}
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/[^0-9.]/g, "")
                      .replace(/(\..*?)\..*/g, "$1");
                  }}
                  // onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9\.]/g, ''); }}
                  onBlur={() => formulaBlur('currency')}
                  required={extra_fields?.required} />
                {isShowIconHoverTooltip && (
                  <span className="input-group-text">
                    <OverlayTrigger placement="bottom" overlay={<Tooltip className="position-absolute" id={`tooltip-${items?.id}`}>{showTooltip?.message}</Tooltip>}>
                      <div style={{ display: 'inline-block' }}>
                        <i className="fa-regular fa-circle-question"></i>
                      </div>
                    </OverlayTrigger>
                  </span>
                )}
              </div>
            )}
            {/* {
              customInputs?.includes(key) && (
                <div className="input-group mt-0">
                  <input type="text" className={`form-control ${error ? 'is-invalid' : ''} border-start-0-`} id={items?.id} placeholder={fieldLabel || ""} value={labelValue || ""}
                    // readOnly
                    onChange={handleInputChange}
                    required={extra_fields?.required}
                    style={{ borderRight: labelValue && 'none' }} />
                  {labelValue &&
                    <span className={`input-group-text bg-white ${extra_fields?.required ? "unique" : ""}`}
                      onClick={(e) => {
                        const event = {
                          target: {
                            id: items?.id,
                            name: items?.name || "",
                            type: items?.type || "",
                            value: "",
                          },
                        };
                        handleInputChange(event);
                      }}
                    >
                      <i className="fa fa-times text-custominput"></i>
                    </span>
                  }
                  <span className={`input-group-text bg-white ${extra_fields?.required ? "unique" : ""}`}
                    // onClick={() => { setLookType(items?.input_type); preview ? {} : setMainModuleSubFormChangeModal(extra_fields) }}
                    onClick={() => {
                      setLookType(items?.input_type);
                      if (!preview) {
                        setMainModuleSubFormChangeModal(extra_fields);
                      }
                    }}
                  ><i className="fa fa-search"></i></span>
                </div>
              )
            } */}
            {items?.input_type === 'date' && (
              <input
                type="date"
                className={`form-control ${error ? 'is-invalid' : ''}`}
                id={items?.id}
                placeholder={items?.label}
                onChange={handleInputChange}
                value={labelValue}
                required={extra_fields?.required}
              />
            )}
            {items?.input_type === 'datetime-local' && (
              <input
                type="datetime-local"
                className={`form-control ${error ? 'is-invalid' : ''}`}
                id={items?.id}
                placeholder={items?.label}
                onChange={handleInputChange}
                value={labelValue}
                required={extra_fields?.required}
              />
            )}
            {items?.input_type === 'file' && (
              <>
                {/* <input
                  type="file"
                  className={`form-control ${error ? 'is-invalid' : ''}`}
                  id={items?.id}
                  placeholder={fieldLabel || ""}
                  onChange={handleInputChange}
                  required={extra_fields?.required}
                /> */}
                {/* {fileData
                  .find(
                    (item) =>
                      item.id === items?.id
                  ) && ( */}
                <div className="border rounded p-2">
                  {fileData
                    .find(
                      (item) =>
                        item.id === items?.id
                    ) && (
                      <div className="img-wrapper">
                        <img
                          src={
                            fileData.find(
                              (item) =>
                                item.id === items?.id
                            ).value
                          }
                          // src="https://d3garweb4bf7l8.cloudfront.net/Digy-CRM/form-attachments/1769614358354-img1.jpg"
                          alt="profile"
                          className="preview-img rounded border mb-2"
                          height={60}
                          width={60}
                        />
                        <span className="remove-icon" onClick={() => removeById(items?.id)}>−</span>
                      </div>
                    )}
                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    className={`form-control ${error ? 'is-invalid' : ''}`}
                    id={items?.id}
                    placeholder={fieldLabel || ""}
                    onChange={handleInputChange}
                    required={extra_fields?.required}
                    accept="image/*"
                  />
                  {/* <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  /> */}
                  <button type="button" className="btn btn-light" onClick={handleButtonClick}>Upload {fieldLabel}</button>
                </div>
                {/* )} */}
              </>
            )}
            {items?.input_type === "image" && (
              <input
                type="file"
                className={`form-control ${error ? "is-invalid" : ""}`}
                id={items?.id}
                placeholder={fieldLabel || ""}
                onChange={handleInputChange}
                required={extra_fields?.required}
              />
            )}
            {items?.input_type === 'url' && (
              <input
                type="url"
                className={`form-control ${error ? 'is-invalid' : ''}`}
                id={items?.id}
                placeholder={fieldLabel || ""}
                onChange={handleInputChange}
                value={labelValue || ''}
                maxLength={maxLength}
                required={extra_fields?.required}
              />
            )}
            {items?.input_type === 'tel' && (
              <input style={{ width: '100%' }}
                type="tel" ref={inputRef}
                className={`form-control ${error ? 'is-invalid' : ''}`}
                id={items?.id}
                placeholder={fieldLabel || ""}
                onChange={() => { }}
                value={labelValue || ""}
                maxLength={maxLength}
                required={extra_fields?.required}
              />
            )}
            {(items?.input_type === 'user' && extra_fields?.user_type === 'single_user') && (
              <div className={`form-control multi-select border-0 p-0 ${extra_fields?.required ? "unique" : ""}`}>
                <label htmlFor={items?.id}>
                  {fieldLabel}
                </label>
                <MutiSelectDropDown preview={preview} options={preview ? (Object?.keys(labelValue)?.length > 0 ? [labelValue] : []) : (users || [])} handleInputChange={handleInputChange} default_value={typeof labelValue === "string" ? null : labelValue} singleSelect={true} isSingleUser={true} isUser={true} />
              </div>
            )}
            {(items?.input_type === 'user' && extra_fields?.user_type === 'multiple_user') && (
              <div className={`form-control multi-select border-0 p-0 ${extra_fields?.required ? "unique" : ""}`}>
                <label htmlFor={items?.id}>
                  {fieldLabel}
                </label>
                <MutiSelectDropDown preview={preview} options={preview ? labelValue || [] : (users || [])} handleInputChange={handleInputChange} default_value={typeof labelValue === "string" ? [] : labelValue} isUser={true} />
              </div>
            )}
            {(isShowIconHoverTooltip && !['currency']?.includes(items?.input_type)) && (
              <span className="input-group-text">
                <OverlayTrigger placement="bottom" overlay={<Tooltip className="position-absolute" id={`tooltip-${items?.id}`}>{showTooltip?.message}</Tooltip>}>
                  <div style={{ display: 'inline-block' }}>
                    <i className="fa-regular fa-circle-question"></i>
                  </div>
                </OverlayTrigger>
              </span>
            )}
            {/* {(['lookup']?.includes(items?.input_type)) && (
              <span className="input-group-text" onClick={() => preview ? {} : setMainModuleSubFormChangeModal(extra_fields)}>
                <i className="fa fa-search"></i>
              </span>
            )} */}
            {/* , 'multi-lookup' */}
            {(['lookup']?.includes(items?.input_type)) && (
              <span className="input-group-text" onClick={() => {
                setLookType(items?.input_type)
                if (preview || (fromAddNewModal && setMainModuleSubFormChangeModal === null)) {
                  return;
                }
                if (setMainModuleSubFormChangeModal && typeof setMainModuleSubFormChangeModal === 'function') {
                  setMainModuleSubFormChangeModal(extra_fields);
                }
              }}>
                <i className="fa fa-search"></i>
              </span>
            )}
            {error && <div id={items?.id} placeholder={fieldLabel || ""} className="invalid-feedback">
              {error}
            </div>
            }
            {(!isShowIconHoverTooltip && items?.input_type !== "tel" && extra_fields?.field_label !== "Participants" && items?.input_type !== "file") && (
              <>
                {modules?.name === "Prospects" && extra_fields?.field_label === "Industry" ? null : (
                  <label className={`${getFormFloatClass() ? 'd-none' : 'd-inline-block'}`} htmlFor={items?.id}>
                    {fieldLabel}
                  </label>
                )}
              </>
            )}
          </div>
        </OverlayTrigger >
        {(isShowIconHoverTooltip && extra_fields?.field_label !== "Participants" || items?.input_type === "tel" && extra_fields?.field_label !== "Participants") && (
          <>
            <label className={`${getFormFloatClass() ? 'd-none' : 'd-inline-block'}`} htmlFor={items?.id}>
              {fieldLabel}
            </label>
          </>
        )
        }
      </div >
      {showAutoGenModal &&
        <ConfigAutoGenNoModal
          showAutoGenModal={showAutoGenModal}
          setShowAutoGenModal={setShowAutoGenModal}
          configModuleType={configModuleType}
          handleAutoNumber={handleAutoNumber}
          configType={configType}
          setConfigType={setConfigType}
          prefix={prefix}
          setPrefix={setPrefix}
          nextNumber={nextNumber}
          setNextNumber={setNextNumber}
          configData={configData}
          id={id}
        />
      }
    </>
  );
};

export default CustomInput;
